/* eslint no-console:0 */
/* eslint no-alert:0 */
/* eslint jsx-a11y/no-noninteractive-element-interactions:0 */
import React from 'react';
import Tree, { TreeNode } from 'rc-tree';
import { selectFolder, deselectFolder, createFtpFolder, setAuthFolders, deleteFtpFolder, toggleCreateFolder, toggleDeleteFolder, clearMessage } from '../action/ftpFolderActions'
import { Container, Card, Button, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import 'rc-tree/assets/index.css'
import '../../css/ftpFolder.css'
import loading from '../../assets/loading.svg'


class FtpFolders extends React.Component {

  constructor(props) {
    super(props);
    this.selKey = {}
    this.state = {
      folderSelected: null
    };
  }

  onExpand = (expandedKeys) => {
    console.log('onExpand', expandedKeys);
  };
  onSelect = (selectedKeys, info) => {
    this.selNode = info.node
    this.selKey = info.node.props;
    this.props.dispatch(selectFolder(info.node))

  };
  onCheck = (checkedKeys, info) => {
    console.log('onCheck', checkedKeys, info);
    var newkeys = [...this.props.newAuthKeys]

    this.props.dispatch(setAuthFolders(checkedKeys))

  };
  onEdit = () => {
    setTimeout(() => {
      console.log('current key: ', this.selKey);
    }, 0);
  };
  onDel = (e) => {
    if (!window.confirm('sure to delete?')) {
      return;
    }
    e.stopPropagation();
  };

  getParentNode(childNode, maybeParentNode) {
    var isChildfilter = maybeParentNode.children(child => {
      return child.key == childNode.key
    })
    if (isChildfilter.length > 0) {
      return maybeParentNode
    }
    else {
      maybeParentNode.children.forEach(child => {
        this.getParentNode(childNode, child)
      })
    }

  }


  render() {


    const DeleteBtn = (() => {
      if (this.props.selectedFolder.props.name && !this.cantDelete) {
        return <Button hidden={!this.props.selectedFolder.props.name || this.cantDelete} onClick={() => {
          console.log('delete', this.props.selectedFolder.props.path)
          //     this.setState({showDelete : false})
          this.props.dispatch(toggleDeleteFolder())
          this.props.dispatch(deleteFtpFolder({ path: this.props.selectedFolder.props.path, publicCode: this.props.code, dirs: this.props.authKeys, email: this.props.userName }))
          this.props.dispatch(deselectFolder())
          this.selKey = {}
          this.selNode = {}
          this.cantDelete = false
        }}>Delete</Button>
      }
      else return ''
    })

    const CreateFolderBody = (() => {
      if (this.props.selectedFolder.props.name) {
        return <Modal.Body>
          <h4>Create Sub-folder under {this.props.selectedFolder.props.name}</h4>
          <input placeholder='Sub-folder Name' onChange={(e) => {
            this.subFolder = `${this.props.selectedFolder.props.path}\\${e.target.value}`
          }} />
        </Modal.Body>
      }
      else {
        return <Modal.Body>
          <h4>Please select a parent folder.</h4>

        </Modal.Body>
      }
    })

    const DeleteFolderBody = (() => {
      if (this.props.selectedFolder.props.name) {

        let children = this.props.selectedFolder.getNodeChildren()
        let nonHidden = children.filter(n => {
          return n.props.name != '|hidden|'
        })

        if (this.props.selectedFolder.props.name === 'Export' || this.props.selectedFolder.props.name === 'Import') {
          this.cantDelete = true
          return <Modal.Body>
            <h4>Cannot delete {this.props.selectedFolder.props.name} folder.</h4>
          </Modal.Body>
        }

        else if (this.props.selectedFolder.props.className && this.props.selectedFolder.props.className.includes('root')) {
          this.cantDelete = true
          return <Modal.Body>
            <h4>Cannot delete root folder.</h4>
          </Modal.Body>
        }

        if (nonHidden.length == 0) {
          return <Modal.Body>
            <h4>Are you sure you want to delete folder "{this.props.selectedFolder.props.name}" ?</h4>
          </Modal.Body>
        }
        else {
          this.cantDelete = true
          return <Modal.Body>
            <h4>"{this.props.selectedFolder.props.name}" has child folders. Please delete those first and try again.</h4>
          </Modal.Body>
        }


      }
      else {
        return <Modal.Body>
          <h4>Please select a folder to delete.</h4>

        </Modal.Body>
      }
    })

    const UserTree = (() => {
      if (this.props.userTree && !this.props.loading)
        return (
          <Tree ref={tree => this.tree = tree}
            showLine
            draggable
            checkable={true}
            selectable={true}
            defaultExpandAll={true}
            defaultCheckedKeys={this.props.newAuthKeys}
            onExpand={this.onExpand}
            onSelect={this.onSelect}
            onCheck={this.onCheck}
            treeData={this.props.userTree}
            selectedKeys={[this.props.selectedFolder.props.path]}
          />
        )
      else {
        return ''
      }

    })
    return (
      <div>

        <Container style={{ width: '50%' }}>
          <Card>
            {/*  <Card.Header>
      <Button onClick={()=>{
          this.setState({showCreate: true})
        }} className='imgBtn'>
             <img src={addFolder} />
           </Button> *
           <Button onClick={()=>{
          this.setState({showDelete: true})
        }} className ='imgBtn'>
             <img disabled={!this.state.folderSelected} src={deleteFolder} style={{marginBottom : '10px', height : '30px'}} />
           </Button>
           <Button className='imgBtn' onClick={()=>{
                
             var input = {}
             input.publicCode = this.props.code
             input.dirs = this.props.newAuthKeys
             input.userName = this.props.userName
             console.log('saving', input)
             this.props.dispatch(saveUserFolders(input))
           }}> <img style={{height : '30px'}} src={save} /></Button>
          </Card.Header> */}
            <Card.Body>
              <div style={{ textAlign: 'left' }}>
                <UserTree />
              </div>

              <img hidden={!this.props.loading} style={{ margin: 'auto', width: '50%' }} src={loading} />


            </Card.Body>
          </Card>




        </Container>

        <Modal show={this.props.showCreate}>
          <Modal.Header>
            <Modal.Title>
              Create Folder
            </Modal.Title>

          </Modal.Header>



          <CreateFolderBody />

          <Modal.Footer>
            <Button onClick={() => {
              //   this.setState({showCreate : false})
              this.props.dispatch(toggleCreateFolder())
              this.selKey = {}
              this.selNode = {}
              this.cantDelete = false
              this.props.dispatch(deselectFolder())
            }} variant='danger'>
              Cancel
               </Button>
            <Button hidden={!this.props.selectedFolder.props.name} onClick={() => {
              console.log('creating', this.subFolder)
              this.props.dispatch(toggleCreateFolder())
              this.props.dispatch(createFtpFolder({ path: this.subFolder, publicCode: this.props.code, dirs: this.props.authKeys, email: this.props.userName }))
              this.props.dispatch(deselectFolder())
              this.cantDelete = false
            }}>Create</Button>
          </Modal.Footer>
        </Modal>

        <Modal variant='danger' show={this.props.showDelete}>
          <Modal.Header>
            <Modal.Title>
              Delete Folder
             </Modal.Title>
          </Modal.Header>

          <DeleteFolderBody />

          <Modal.Footer>
            <Button onClick={() => {
              // this.setState({showDelete : false})
              this.props.dispatch(toggleDeleteFolder())
              this.selKey = {}
              this.selNode = {}
              this.cantDelete = false
            }} variant='danger'>
              Cancel
               </Button>
            <DeleteBtn />
          </Modal.Footer>
        </Modal>

        <Modal variant='danger' show={this.props.ioMessage}>
          <Modal.Header>
            Result
          </Modal.Header>
          <Modal.Body>
            <h4>{this.props.ioMessage}</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => {
              this.props.dispatch(clearMessage())
            }}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>

      </div>



    );
  }
}

const mapStateToProps = state => (
  {
    tree: state.ftp.folder.tree,
    error: state.ftp.folder.error,
    loading: state.ftp.folder.loading,
    userTree: state.ftp.folder.userTree,
    authKeys: state.ftp.folder.authKeys,
    newAuthKeys: state.ftp.folder.newAuthKeys,
    showCreate: state.ftp.folder.showCreate,
    showDelete: state.ftp.folder.showDelete,
    ioMessage: state.ftp.folder.ioMessage,
    selectedFolder: state.ftp.folder.selectedFolder
  });



export default connect(mapStateToProps)(FtpFolders)